import { memo, useRef, useState } from 'react';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn';
import { useNavigate } from 'react-router-dom';
import { GetBrokerPatientsListGroups, GetBrokerPatientsTemplate } from '@/api/endpoints/Broker/BrokerPatient';
import ScreenHeader from '@/components/ScreenHeader';
import ActionBtn from '@/components/ActionBtn';
import { DateValue } from '@/components/tableDrawer';
import { ColumnsGenerator } from '@/utils/tableUtils';
import UploadSheetPopup from './Popups/UploadSheetPopup';
import { AttachmentsUploadedCell, CategoryRequestCell, NameRequestCell } from './RowsData';
import './style.css';

const PatientsListGroups = () => {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)

    const refModal = useRef(null)

    const columns = [
        ColumnsGenerator.SearchableTextCell('groupName'),
        ColumnsGenerator.HiddenSearchableText('patientName'),
        ColumnsGenerator.CustomCell('patientName', (original) => <NameRequestCell original={{ ...original, patientName: `${original.firstName} ${original.lastName}`, requestId: original.patientId }} />),
        ColumnsGenerator.TextCell('gender'),
        ColumnsGenerator.CustomCell('category', (original) => <CategoryRequestCell original={original} />),
        ColumnsGenerator.CustomCell('startDate', (original) => <DateValue value={original.startDate} />),
        ColumnsGenerator.CustomCell('endDate', (original) => <DateValue value={original.endDate} />),
        ColumnsGenerator.CustomCell('isAttachmentsUploaded', (original) => <AttachmentsUploadedCell original={original} />),

        ColumnsGenerator.CustomCell('action', (original) =>
            <>
                <BaseBtn onApply={() => viewRequestDetails(original)}
                    title="view-details"
                    className="details-info"
                    reqAction="canGet"
                    icon={"mdi:eye"} />
            </>
        )]

    const viewRequestDetails = (original) =>
        navigate(`/panel/provider/medical-request/${original?.id}/${original?.orderStatusId}`)


    const downloadTemplate = () => {
        setIsLoading(true)
        GetBrokerPatientsTemplate().then(_ => { }).finally(() => setIsLoading(false))
    }
    
    return (
        <>
            <ScreenHeader title="Patients List Groups" >
                <div className='actions-container'>
                    <ActionBtn className='broker-actions download-template' title="download-template" icon={isLoading ? "eos-icons:loading" : "material-symbols-light:download-rounded"} onApply={downloadTemplate} isDisabled={isLoading} />
                    <ActionBtn className='broker-actions upload-excel' title="upload-excel" icon="material-symbols-light:upload-rounded" onApply={() => refModal.current.click()} />
                    <ActionBtn className='broker-actions add-new-paitent' title="add-new-paitent" icon="mdi:plus" onApply={() => navigate('/panel/broker/clients/patientsListGroups/viewStats')} />
                    <ActionBtn className='broker-actions submit' title="submit" icon="prime:send" onApply={() => navigate('/panel/broker/clients/patientsListGroups/downloadTemplate')} />
                </div>
            </ScreenHeader>

            <UploadSheetPopup refModal={refModal} />

            <ReportContent tableAPI={GetBrokerPatientsListGroups} columns={columns}>
                <ReportHeader  >
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>
        </>
    );
}

export default memo(PatientsListGroups);